import { c as _c } from "react/compiler-runtime";
import { IdDocImageTypes } from '@onefootprint/types';
import { OpenCvProvider } from 'opencv-react-ts';
import { useEffect } from 'react';
import { trackAction } from '@/idv/utils';
import { ImgProcessorsContextProvider } from '../components/image-processors';
import { MissingPermissionsSheetProvider } from '../components/missing-permissions-sheet';
import { getOpenCvUrl } from '../constants';
import { FaceModelProvider } from '../hooks/use-face-model-loader';
import { OpenCvGuard } from '../hooks/use-open-cv-guard';
import { MachineProvider } from './components/machine-provider';
import Router from './pages/router';
import type { IdDocProps } from './types';
import type { MachineContext } from './utils/state-machine';
const IdDoc = t0 => {
  const $ = _c(22);
  const {
    initialContext,
    onDone
  } = t0;
  const {
    authToken,
    device,
    sandboxOutcome,
    requirement,
    config
  } = initialContext;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      country: undefined,
      type: undefined
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = device.initialCameraPermissionState || "prompt";
  let t3;
  if ($[1] !== authToken || $[2] !== config || $[3] !== device || $[4] !== requirement || $[5] !== sandboxOutcome || $[6] !== t2) {
    t3 = {
      authToken,
      device,
      requirement,
      isConsentMissing: requirement.config.shouldCollectConsent,
      currSide: IdDocImageTypes.front,
      idDoc: t1,
      allowPdf: false,
      sandboxOutcome,
      cameraPermissionState: t2,
      onboardingConfig: config
    };
    $[1] = authToken;
    $[2] = config;
    $[3] = device;
    $[4] = requirement;
    $[5] = sandboxOutcome;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const context = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(_temp, t4);
  const t5 = requirement.config.shouldCollectSelfie;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getOpenCvUrl();
    t7 = <OpenCvGuard />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onDone) {
    t8 = <OpenCvProvider openCvPath={t6}>{t7}<ImgProcessorsContextProvider><Router onDone={onDone} /></ImgProcessorsContextProvider></OpenCvProvider>;
    $[11] = onDone;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== requirement.config.shouldCollectSelfie || $[14] !== t8) {
    t9 = <FaceModelProvider isSelfieRequired={t5}>{t8}</FaceModelProvider>;
    $[13] = requirement.config.shouldCollectSelfie;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== device || $[17] !== t9) {
    t10 = <MissingPermissionsSheetProvider device={device}>{t9}</MissingPermissionsSheetProvider>;
    $[16] = device;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== context || $[20] !== t10) {
    t11 = <MachineProvider args={context}>{t10}</MachineProvider>;
    $[19] = context;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default IdDoc;
function _temp() {
  trackAction("id-doc:started");
}